module.exports = __webpack_public_path__ + "static/favicon-2720816c4e754a7348c109eedc02d1f4.png";